import React from "react";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f7f9fc] px-6">
        <div className="w-full max-w-sm rounded-[24px] border border-slate-200 bg-white p-8 shadow-[0_24px_60px_-28px_rgba(15,23,42,0.18)] text-center">
          <div className="mb-4 inline-flex h-14 w-14 items-center justify-center rounded-[18px] border border-rose-100 bg-rose-50 text-rose-500">
            <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>
          <h2 className="mb-1.5 text-[17px] font-bold text-slate-900">Что-то пошло не так</h2>
          <p className="mb-6 text-sm text-slate-500">Страница не смогла загрузиться. Попробуйте обновить.</p>
          <button
            onClick={() => window.location.reload()}
            className="w-full rounded-full bg-[#229ED9] px-4 py-3 text-sm font-semibold text-white transition hover:bg-[#1a8fc4]"
          >
            Перезагрузить страницу
          </button>
        </div>
      </div>
    );
  }
}
